import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { YEAR } from '../../../constants';
import '../CallForSpeakers.scss';
import {
  SubmitFailedMessage,
  InProgress,
  MissingFieldsMessage,
  UnsavedPhotoMessage
} from './Messages';
import { AddSpeakerButton } from './Buttons';
import SpeakerDetail from './SpeakerDetail';

const CFSForm = ({
  closeAlert,
  fields,
  formFailed,
  formSubmitInProgress,
  isValidForm,
  isValidValue,
  onSubmit,
  updateCheckboxValue,
  updateValue,
  addSpeaker,
  updateSpeaker,
  removeSpeaker,
  isValidSpeakerValue,
  handleObserve,
  isDirty
}) => {
  const submitRef = useRef();

  useEffect(() => {
    handleObserve(submitRef);
  }, [handleObserve]);

  return (
    <div className="container cfs-form">
      <form className="form-horizontal" noValidate onSubmit={onSubmit}>
        <div className="is-divider custom-divider" data-content="Talk detail" />
        <div className="form-group columns">
          <label
            className={`control column is-2 label req ${
              isValidValue('talkTitle') ? '' : ' has-error'
            }`}
            htmlFor="talkTitle">
            {fields.talkTitle.label}
          </label>
          <div className="column fix-space-sm">
            <input
              className={`form-control input is-rounded ${
                isValidValue('talkTitle') ? '' : ' is-danger'
              }`}
              name="talkTitle"
              onChange={updateValue}
              placeholder="Talk Title"
              type="text"
              value={fields.talkTitle.value}
            />
          </div>
          <label
            className={`control column is-2 label req ${isValidValue('track') ? '' : ' has-error'}`}
            htmlFor="track">
            {fields.track.label}
          </label>
          <div className="column">
            <div
              className={`select custom-select-sm level-right is-rounded ${
                isValidValue('track') ? '' : ' is-danger'
              }`}>
              <select
                className="custom-select"
                name="track"
                onChange={updateValue}
                value={fields.track.value}>
                <option value="">Select type</option>
                <option>40-minute Talk</option>
                <option>Interactive 3-hour Hands-on Lab</option>
                <option>10-minute Lightning Talk </option>
              </select>
            </div>
          </div>
        </div>
        {fields.track.value === 'Talk' && (
          <div
            className={`form-group field is-horizontal columns stream ${
              isValidValue('stream') ? '' : ' has-error'
            }`}>
            <label
              className={`control column is-2 label req ${
                isValidValue('stream') ? '' : ' has-error'
              }`}
              htmlFor="stream">
              {fields.stream.label}
            </label>
            <div className="control field alignment column">
              <div className="field">
                <label>
                  <input
                    checked={fields.stream.value.includes('User Interaction')}
                    name="stream"
                    onChange={updateCheckboxValue}
                    type="checkbox"
                    value="User Interaction"
                  />{' '}
                  User Interaction
                </label>
              </div>
              <div className="field">
                <label>
                  <input
                    checked={fields.stream.value.includes('Application Logic')}
                    name="stream"
                    onChange={updateCheckboxValue}
                    type="checkbox"
                    value="Application Logic"
                  />{' '}
                  Application Logic
                </label>
              </div>
              <div className="field">
                <label>
                  <input
                    checked={fields.stream.value.includes('Data Science')}
                    name="stream"
                    onChange={updateCheckboxValue}
                    type="checkbox"
                    value="Data Science"
                  />{' '}
                  Data Science
                </label>
              </div>
              <div className="field">
                <label>
                  <input
                    checked={fields.stream.value.includes('Dev-Sec-Ops')}
                    name="stream"
                    onChange={updateCheckboxValue}
                    type="checkbox"
                    value="Dev-Sec-Ops"
                  />{' '}
                  Dev-Sec-Ops
                </label>
              </div>
            </div>
            <div className="control column is-2 label"> </div>
            <div className="control field alignment column">
              <div className="field">
                <label>
                  <input
                    checked={fields.stream.value.includes('Innovation and Sustainability')}
                    name="stream"
                    onChange={updateCheckboxValue}
                    type="checkbox"
                    value="Innovation and Sustainability"
                  />{' '}
                  Innovation and Sustainability
                </label>
              </div>
              <div className="field">
                <label>
                  <input
                    checked={fields.stream.value.includes('Live Coding Session')}
                    name="stream"
                    onChange={updateCheckboxValue}
                    type="checkbox"
                    value="Live Coding Session"
                  />{' '}
                  Live Coding Session
                </label>
              </div>
              <div className="field">
                <label>
                  <input
                    checked={fields.stream.value.includes('Lightning Talk')}
                    name="stream"
                    onChange={updateCheckboxValue}
                    type="checkbox"
                    value="Lightning Talk"
                  />{' '}
                  Lightning Talk
                </label>
              </div>
              <div className="field">
                <label>
                  <input
                    checked={fields.stream.value.includes('Other')}
                    name="stream"
                    onChange={updateCheckboxValue}
                    type="checkbox"
                    value="Other"
                  />{' '}
                  Other
                </label>
              </div>
            </div>
          </div>
        )}
        <div className="form-group columns">
          <label
            className={`control column is-2 label req ${
              isValidValue('talkSummary') ? '' : ' has-error'
            }`}
            htmlFor="talkSummary">
            {fields.talkSummary.label}
          </label>
          <div className="column">
            <textarea
              className={`form-control textarea ${isValidValue('talkSummary') ? '' : ' is-danger'}`}
              name="talkSummary"
              onChange={updateValue}
              placeholder="Talk Summary"
              rows="2"
              value={fields.talkSummary.value}
            />
          </div>
        </div>
        <div className="form-group field is-horizontal columns">
          <label
            className={`control column is-2 is-left label req ${
              isValidValue('talkType') ? '' : ' has-error'
            }`}
            htmlFor="talkType">
            {fields.talkType.label}
          </label>
          <div className={`control field column ${isValidValue('talkType') ? '' : ' has-error'}`}>
            <div className="field is-left is-horizontal">
              <label className="radio">
                <input name="talkType" onChange={updateValue} type="radio" value="introduction" />{' '}
                Introduction
              </label>
            </div>
            <div className="field is-left is-horizontal">
              <label className="radio">
                <input name="talkType" onChange={updateValue} type="radio" value="advanced" />{' '}
                Advanced concepts
              </label>
            </div>
            <div className="field is-left is-horizontal">
              <label className="radio">
                <input name="talkType" onChange={updateValue} type="radio" value="expert" /> Deep
                Dive
              </label>
            </div>
          </div>
          <label
            className={`control column is-2 is-left label req ${
              isValidValue('audienceLevel') ? '' : ' has-error'
            }`}
            htmlFor="audienceLevel">
            {fields.audienceLevel.label}
          </label>
          <div
            className={`control field column ${isValidValue('audienceLevel') ? '' : ' has-error'}`}>
            <div className="field is-left is-horizontal">
              <label className="radio">
                <input name="audienceLevel" onChange={updateValue} type="radio" value="beginner" />{' '}
                Beginner
              </label>
            </div>
            <div className="field is-left is-horizontal">
              <label className="radio">
                <input
                  name="audienceLevel"
                  onChange={updateValue}
                  type="radio"
                  value="intermediate"
                />{' '}
                Intermediate
              </label>
            </div>
            <div className="field is-left is-horizontal">
              <label className="radio">
                <input name="audienceLevel" onChange={updateValue} type="radio" value="expert" />{' '}
                Expert
              </label>
            </div>
            <div className="field is-left is-horizontal">
              <label className="radio">
                <input name="audienceLevel" onChange={updateValue} type="radio" value="everyone" />{' '}
                Everyone
              </label>
            </div>
          </div>
        </div>
        <div className="form-group field is-horizontal columns">
          <label
            className={`control column is-2 label req ${
              isValidValue('technicalOrBusiness') ? '' : ' has-error'
            }`}
            htmlFor="technicalOrBusiness">
            {fields.technicalOrBusiness.label}
          </label>
          <div
            className={`field is-left is-horizontal control column ${
              isValidValue('technicalOrBusiness') ? '' : ' has-error'
            }`}>
            <label className="radio radio-inline">
              <input
                checked={fields.technicalOrBusiness.value === 'technical'}
                name="technicalOrBusiness"
                onChange={updateValue}
                type="radio"
                value="technical"
              />{' '}
              Technical
            </label>
            <label className="radio radio-inline">
              <input
                checked={fields.technicalOrBusiness.value === 'business'}
                name="technicalOrBusiness"
                onChange={updateValue}
                type="radio"
                value="business"
              />{' '}
              Business
            </label>
          </div>
        </div>
        <div className="form-group field is-horizontal columns">
          <label
            className={`control column is-2 label req ${
              isValidValue('liveCoding') ? '' : ' has-error'
            }`}
            htmlFor="liveCoding">
            {fields.liveCoding.label}
          </label>
          <div
            className={`field is-left is-horizontal control column ${
              isValidValue('liveCoding') ? '' : ' has-error'
            }`}>
            <label className="radio radio-inline">
              <input
                checked={fields.liveCoding.value === 'yes'}
                name="liveCoding"
                onChange={updateValue}
                type="radio"
                value="yes"
              />{' '}
              Yes
            </label>
            <label className="radio radio-inline">
              <input
                checked={fields.liveCoding.value === 'no'}
                name="liveCoding"
                onChange={updateValue}
                type="radio"
                value="no"
              />{' '}
              No
            </label>
          </div>
        </div>
        {fields.speakers.map(speaker => (
          <SpeakerDetail
            key={speaker.id}
            fields={fields}
            isValidSpeakerValue={isValidSpeakerValue}
            // onDrop={onDrop}
            removeSpeaker={removeSpeaker}
            // resizeImage={resizeImage}
            speaker={speaker}
            updateSpeaker={updateSpeaker}
          />
        ))}
        {fields.speakers.length < 5 && <AddSpeakerButton addSpeaker={addSpeaker} />}
        <div className="is-divider custom-divider" data-content="Social media" />
        <div className="form-group columns">
          <label
            className={`control column is-2 label req  ${
              isValidValue('twitterPromotion') ? '' : ' has-error'
            }`}
            htmlFor="twitterPromotion">
            {fields.twitterPromotion.label}
          </label>
          <div className="column">
            <textarea
              className={`form-control textarea ${
                isValidValue('twitterPromotion') ? '' : ' is-danger'
              }`}
              maxLength="120"
              name="twitterPromotion"
              onChange={updateValue}
              placeholder="Text for Twitter promotion of presentation. Maximum 120 characters including @OpenSlava and speaker’s name."
              rows="2"
              value={fields.twitterPromotion.value}
            />
          </div>
        </div>
        <div className="form-group columns">
          <label
            className={`control column is-2 label req ${
              isValidValue('fbPromotion') ? '' : ' has-error'
            }`}
            htmlFor="fbPromotion">
            {fields.fbPromotion.label}
          </label>
          <div className="column">
            <textarea
              className={`form-control textarea ${isValidValue('fbPromotion') ? '' : ' is-danger'}`}
              maxLength="300"
              name="fbPromotion"
              onChange={updateValue}
              placeholder="Text for Facebook promotion of presentation. Maximum 300 characters."
              rows="2"
              value={fields.fbPromotion.value}
            />
          </div>
        </div>
        <div className="columns">
          <div className="first-consent-section column is-12">
            <h2 className="title is-5 consent-title">Acknowledgement and consent</h2>
            <p>
              You agree by ticking the below “yes” box that companies Accenture s.r.o., Id. No.: 35
              724 498 and Accenture Technology Solutions – Slovakia, s.r.o. Id. No.: 35 864 648,
              seated both at Plynárenská 7/C, 821 09 Bratislava, in connection with the conference
              OpenSlava {YEAR}:
            </p>
            <ul>
              <li>
                may process your personal data indicated herein, except for the e-mail address,
                including publishing in any material published or distributed to individuals,
                through any type of media including social media (e.g. online, print, TV);
              </li>
              <li>
                may use/publish your photographs and/or video/audio recordings of your participation
                and presentation to promote and inform about the event.
              </li>
            </ul>
            <p className="acknowledgement req">
              I acknowledge having read and understood this privacy statement, and consent to the
              above:
            </p>
          </div>
        </div>
        <div
          className={`form-group is-horizontal columns checkbox field control ${
            isValidValue('disclaimer') ? '' : ' has-error'
          }`}>
          <label className="column field cfs-disclaimer">
            <input
              checked={fields.disclaimer.value}
              name="disclaimer"
              onChange={updateValue}
              type="checkbox"
            />{' '}
            yes
          </label>
        </div>
        <div className="columns">
          <div className="second-consent-section column is-12">
            <p>
              With regard to nominating a talk or taking part in a panel discussion, the speaker
              agrees, in its own name as well as on behalf of the company/institution the speaker
              represents, if any:
            </p>
            <ul>
              <li>With the recording of the talk / panel discussion,</li>
              <li>Its live online streaming, and</li>
              <li>
                Publishing the recording of the talk / panel discussion during and after the
                OpenSlava 2023 conference, incl. the history site of OpenSlava conference’s web page
                and OpenSlava YouTube channel,
              </li>
            </ul>
            <p>
              unless the speaker, or entity the speaker represents, contacts Accenture, Mr. Robert
              Belavy – robert.belavy@accenture.com,{' '}
              <span className="acknowledgement req">
                to agree upon any exclusions or limitations from the consent given here.
              </span>
            </p>
          </div>
        </div>
        <div
          className={`form-group is-horizontal columns checkbox field control ${
            isValidValue('videoDisclaimer') ? '' : ' has-error'
          }`}>
          <label className="column field cfs-disclaimer">
            <input
              checked={fields.videoDisclaimer.value}
              name="videoDisclaimer"
              onChange={updateValue}
              type="checkbox"
            />{' '}
            I Agree
          </label>
        </div>
        <div className="columns">
          <div className="third-consent-section column is-12">
            <p>
              Your privacy is important to us. Accenture uses your personal data only in compliance
              with data protection laws. For further information on how Accenture processes your
              personal data, please see our{' '}
              <a
                href="https://www.accenture.com/us-en/privacy-policy"
                rel="noopener noreferrer"
                target="_blank">
                Accenture Privacy Statement
              </a>
              .
            </p>
          </div>
        </div>
        <MissingFieldsMessage isValidForm={isValidForm} />
        <UnsavedPhotoMessage isDirty={isDirty} />
        <SubmitFailedMessage closeAlert={closeAlert} formFailed={formFailed} />
        <InProgress formSubmitInProgress={formSubmitInProgress} />
        <div className="submit">
          <button
            ref={submitRef}
            className="button is-large is-rounded btn-submit"
            disabled={!isValidForm() || formSubmitInProgress}
            type="submit">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

CFSForm.propTypes = {
  addSpeaker: PropTypes.func.isRequired,
  closeAlert: PropTypes.func.isRequired,
  // eslint-disable-next-line
  fields: PropTypes.object.isRequired,
  formFailed: PropTypes.bool.isRequired,
  formSubmitInProgress: PropTypes.bool.isRequired,
  isValidForm: PropTypes.func.isRequired,
  isValidSpeakerValue: PropTypes.func.isRequired,
  isValidValue: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  removeSpeaker: PropTypes.func.isRequired,
  updateCheckboxValue: PropTypes.func.isRequired,
  updateSpeaker: PropTypes.func.isRequired,
  updateValue: PropTypes.func.isRequired
};

export default CFSForm;
